<div *ngIf="!isAuthRoute(); else authRoute">
    <!-- Content for non-auth routes -->
    <app-loader></app-loader>
    <div class="d-flex">
        <!-- For desktop and larger screens -->
        <app-sidebar [isOpen]="isOpen" [isToggle]="isToggle"></app-sidebar>

        <div class="content flex-grow-1 pt-1 px-2 pt-lg-4 px-lg-3">
            <app-header (toggleSidebar)="toggleSidebar($event)" (smallSidebar)="smallSidebar($event)"></app-header>
            <div class="card">
                <app-breadcrumb></app-breadcrumb>
                <router-outlet></router-outlet>
            </div>
            <app-footer></app-footer>
        </div>
    </div>
    <div style="position: fixed; bottom: 20px; right: 20px; z-index: 10000; padding: 10px;" class="button-bug">
        <button class="btn btn-primary" (click)="openBugWidget()">Feedback</button>
    </div>
</div>

<!-- Only auth routes -->
<ng-template #authRoute>
    <router-outlet></router-outlet>
    <div style="position: fixed; bottom: 20px; right: 20px; z-index: 10000; padding: 10px;">
        <button class="btn btn-primary" (click)="openBugWidget()">Feedback</button>
    </div>
</ng-template>
